import React from 'react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/classic-calendar-skeleton.tpl.svg';

export const ClassicCalendarSkeleton = () => <AppSkeletonImage src={imgSVG} />;
